import { api } from "../lib/api";
import type { ProviderListResponse } from "../types/provider";

/**
 * Phase 37 — GET /api/user/providers
 *
 * Returns the patient's connected providers for ContactPicker. era-api
 * source: routes/user.ts:466 + services/userService.ts:1001. Joins
 * `providerPatientRelationships` and returns active + onboarding rows.
 * Used by `useUserProviders` (TanStack Query, 5min staleTime).
 */
export async function getUserProviders(): Promise<ProviderListResponse> {
	const response = await api.get<ProviderListResponse>("/api/user/providers");
	return response.data;
}
